import React from 'react';

export function festivalOptionLabel(festival, activeSlug) {
  const status = festival.slug === activeSlug ? 'فعال' : 'غیرفعال';
  return `${status} — ${festival.name}`;
}

export default function FestivalSwitcher({activeFestival, festivals, busy, error, onChange}) {
  const availableFestivals = festivals.length ? festivals : [activeFestival];

  return (
    <div className="mx-3 hidden flex-col text-xs text-white md:flex">
      <label className="flex items-center gap-2" htmlFor="active-festival-selector">
        جشنواره فعال
        <select
          id="active-festival-selector"
          aria-label="جشنواره فعال"
          className="rounded border-0 bg-theme-1 px-2 py-1"
          value={activeFestival.slug}
          disabled={busy}
          onChange={(event) => onChange(event.target.value)}
        >
          {availableFestivals.map((item) => (
            <option key={item.slug} value={item.slug}>
              {festivalOptionLabel(item, activeFestival.slug)}
            </option>
          ))}
        </select>
      </label>
      <a className="mt-1 text-left text-white text-opacity-70 hover:text-opacity-100" href="/settings/festivals">
        مدیریت جشنواره‌ها
      </a>
      {error ? <span className="mt-1 text-red-200" role="alert">{error}</span> : null}
    </div>
  );
}

